import { baseApi } from '@/app/store/api/baseApi';
import { HttpMethods } from '@/app/types';
import { URL_API_PUBLIC } from '@/shared/urls';

interface SubscriptionResponse {
  status: boolean;
}

export const subscriptionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createMailSubscription: builder.mutation<SubscriptionResponse, string>({
      query: (email) => ({
        url: URL_API_PUBLIC.subscription,
        method: HttpMethods.post,
        body: { email },
      }),
    }),
  }),
});

export const { useCreateMailSubscriptionMutation } = subscriptionApi;
